/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-07-03 20:10:30
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-28 17:34:06
 */
import request from '@/service/request'
enum Api {
  STATION_DIMSTATION = '/station/dimStation',
  STATION_LIST = '/station/list',
  STATION_EDIT = '/station/edit',
  STATION_DETAIL = '/station/detail',
  STATION_BATCHDISABLE = '/station/batchDisable',
  STATION_EXPORT = '/export/exportAdminStation',
  STATION_EXPORTASYNC = '/export/exportAdminStationAsync'
}

export default class siteService {
  /**
   * 计算距离
   * @param data
   * @returns
   */
  static getLocationDistance(data: Record<string, any>): Promise<any> {
    return request.post('/station/getLocationDistance', data)
  }
  /**
   * 导出
   * @param data
   * @returns
   */
  static exportAdminStation(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_EXPORT, data, true)
  }
  /**
   * 异步导出
   * @param data
   * @returns
   */
  static exportAdminStationAsync(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_EXPORTASYNC, data, true)
  }
  /**
   * 驿站模糊搜索
   * @param data
   * @returns
   */
  static dimStation(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_DIMSTATION, data)
  }

  /**
   * list
   * @param data
   * @returns
   */
  static list(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_LIST, data)
  }
  /**
   * 驿站编辑
   * @param data
   * @returns
   */
  static edit(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_EDIT, data)
  }
  /**
   * 驿站详情
   * @param data
   * @returns
   */
  static detail(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_DETAIL, data)
  }
  /**
   * 驿站批量禁用
   * @param data
   * @returns
   */
  static batchDisable(data: Record<string, any>): Promise<any> {
    return request.post(Api.STATION_BATCHDISABLE, data)
  }
  /**
   * 获取绑定快递员信息
   * @param data
   * @returns
   */
  static getCourier(data: Record<string, any>): Promise<any> {
    return request.post('/station/getCourier', data)
  }
  /**
   * 获取绑定快递员确认信息
   * @param data
   * @returns
   */
  static getCourierConfirm(data: Record<string, any>): Promise<any> {
    return request.customPost('/station/getCourier', data, { NoAlert: true })
  }
  /**
   * 根据地址id查询机构信息
   * @param params addressId
   * @returns
   */
  static queryAgencyByAddressId(params: Record<string, any>): Promise<any> {
    return request.get('/address/queryAgencyByAddressId', params)
  }
  /**
   * 获取区域对应的客户编码
   * @param params agencyId 代理区id, starLevel 站点星级
   * @returns
   */
  static getCustomerCodeByAgencyId(params: Record<string, any>): Promise<any> {
    return request.get('/vn/station/customerCode', params)
  }
}
